function setHeaderHeight() {
    var header = document.querySelector(".main-header");
    var adminBar = document.getElementById("wpadminbar");

    var headerHeight = header ? header.offsetHeight : 0;
    var adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

    document.body.style.setProperty(
        "--header-height",
        (headerHeight + adminBarHeight) / 16 + "rem"
    );
}

setHeaderHeight();
